import { render, staticRenderFns } from "./objection-request.vue?vue&type=template&id=40e633bf&scoped=true&"
import script from "./objection-request.vue?vue&type=script&lang=js&"
export * from "./objection-request.vue?vue&type=script&lang=js&"
import style0 from "./objection-request.vue?vue&type=style&index=0&id=40e633bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e633bf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VIcon,VRow,VSheet,VSkeletonLoader})
